export const SALUTATION = {
    FEMALE: 1,
    MALE: 2
};
//# sourceMappingURL=salutation.js.map
